import { createFileRoute } from "@tanstack/react-router";
import { ReservedHostsPage } from "../../features/reserved-hosts/servers";

export const Route = createFileRoute("/_authed/$org/$project/reservedhosts/")({ component: Servers });
function Servers() {
  const scope = Route.useParams();
  return <ReservedHostsPage scope={scope} />;
}
